<template>
  <section class="py-5 bg-white text-dark">
    <div class="container">
      <h1 class="mb-4 text-primary fw-bold">Modificarea legii achizițiilor publice – OUG 45/2018</h1>

      <p>
        Legea achizițiilor publice a fost modificată prin <strong>Ordonanța de Urgență nr. 45/2018</strong>, publicată în Monitorul Oficial și intrată în vigoare în data de <strong>04 iunie 2018</strong>.
      </p>

      <p>
        Principala noutate a fost <strong>modificarea pragurilor valorice</strong> prevăzute de <strong>Legea 98/2016</strong>, precum și stabilirea unor condiții mai clare pentru utilizarea criteriului „prețul cel mai scăzut”.
      </p>

      <h5 class="mt-4 fw-semibold"><i class="fas fa-coins me-2"></i>Praguri valorice actualizate (fără TVA):</h5>
      <ul>
        <li><i class="fas fa-arrow-right me-2 text-primary"></i><strong>24.977.096 lei</strong> – pentru lucrări</li>
        <li><i class="fas fa-arrow-right me-2 text-primary"></i><strong>648.288 lei</strong> – pentru produse și servicii</li>
        <li><i class="fas fa-arrow-right me-2 text-primary"></i><strong>994.942 lei</strong> – pentru produse și servicii atribuite de autorități locale (CJ, CL, CGMB)</li>
        <li><i class="fas fa-arrow-right me-2 text-primary"></i><strong>3.376.500 lei</strong> – pentru servicii sociale și alte servicii specifice (Anexa 2)</li>
      </ul>

      <h5 class="mt-4 fw-semibold"><i class="fas fa-file-contract me-2"></i>Achiziții directe permise:</h5>
      <ul>
        <li><i class="fas fa-check me-2 text-success"></i>Produse/servicii – dacă valoarea este <strong>&lt; 135.060 lei</strong></li>
        <li><i class="fas fa-check me-2 text-success"></i>Lucrări – dacă valoarea este <strong>&lt; 450.200 lei</strong></li>
      </ul>

      <h5 class="mt-4 fw-semibold"><i class="fas fa-clipboard-check me-2"></i>Criteriul „prețul cel mai scăzut”</h5>
      <p>
        Conform noii reglementări, acest criteriu poate fi folosit <strong>doar dacă valoarea estimată</strong> a contractului nu depășește pragurile de mai sus.
      </p>

      <p class="mt-4">
        Experții noștri în achiziții publice oferă consultanță atât autorităților contractante, cât și operatorilor economici care doresc să participe la proceduri de atribuire, în conformitate cu noile reglementări aduse de OUG 45/2018.
      </p>

      <p>
        Pentru asistență profesională privind praguri, criterii de evaluare și eligibilitate:
        <br />
        <strong><i class="fas fa-envelope me-1"></i>contact@consultantaachizitii.ro</strong>
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'OuG45'
}
</script>
